import { call, put, takeEvery } from "redux-saga/effects"

// Crypto Redux States
import {
  GET_USERS_DATA,
  UPDATE_USER_DATA,
  CREATE_USER,
  UPDATE_USER,
  DELETE_USER,
  GET_USER,
  GET_ASSESSMENTS_DATA,
  ADD_ASSESSMENT,
  UPDATE_ASSESSMENT_DATA,
  STEP_BACK,
  STEP_NEXT,
  CLEAR_ASSESSMENT_ID,
  CREATE_PATIENT,
  GET_PATIENT_DATA,
  UPDATE_PATIENT,
  DELETE_PATIENT,
  CLONE_ASSESSMENT,
  CLONE_CAREPLAN,
  DELETE_ASSESSMENT,
  GET_DOMAINS_REQUEST,
  GET_ADMIN_DASHBOARD_SUMMARY_REQUEST,
  GET_ADMIN_DASHBOARD_SIGNUPS_REQUEST,
  GET_ADMIN_DASHBOARD_DOCS_MONTHLY_REQUEST,
  GET_ADMIN_DASHBOARD_COMPANY_TYPES_REQUEST,
  GET_ADMIN_DASHBOARD_ACTIVE_SESSIONS_REQUEST,
  GET_ME_DASHBOARD_SUMMARY_REQUEST,
  GET_ME_DASHBOARD_DAILY_DOCS_REQUEST,
  GET_ME_DASHBOARD_DOCS_MONTHLY_REQUEST,
  GET_ME_DASHBOARD_TOP_TYPES_REQUEST,
} from "./actionTypes"
import {
  apiSuccess,
  apiFail,
  updateFail,
  updateSuccess,
  createUserSuccess,
  createUserFail,
  getUserSuccess,
  getUserFail,
  getDomainsSuccess,
  getDomainsFailure,
  assessmentapiSuccess,
  assessmentapiFail,
  addAssessmentSuccess,
  addAssessmentFail,
  updateUserSuccess,
  updateUserFail,
  deleteUserSuccess,
  deleteUserFail,
  updateAssessmentSuccess,
  updateAssessmentFail,
  stepBack,
  clearAssessmentId,
  createPatientFail,
  getPatientDataSuccess,
  getPatientDataFail,
  updatePatientSuccess,
  updatePatientFail,
  deletePatientSuccess,
  deletePatientFail,
  createPatientSuccess,
  cloneAssessmentSuccess,
  cloneAssessmentFail,
  deleteAssessmentSuccess,
  deleteAssessmentFail,
  getAdminDashboardSummarySuccess,
  getAdminDashboardSummaryFailure,
  getAdminDashboardSignupsSuccess,
  getAdminDashboardSignupsFailure,
  getAdminDashboardDocsMonthlySuccess,
  getAdminDashboardDocsMonthlyFailure,
  getAdminDashboardCompanyTypesSuccess,
  getAdminDashboardCompanyTypesFailure,
  getAdminDashboardActiveSessionsSuccess,
  getAdminDashboardActiveSessionsFailure,
} from "./actions"

//Include Both Helper File with needed methods
import {
  users,
  createUserData,
  updateUserData,
  deleteUserData,
  getUserData,
  fetchDomainsApi,
  assessments,
  addAssessment,
  updateAssessmentData,
  deleteAssessments,
  getPatientsData,
  createNewPatient,
  updatePatients,
  deletePatients,
  clonePchAssessmentData,
  fetchAdminData,
  fetchAdminActiveSessions,
  fetchAdminCompanyTypes,
  fetchAdminDocumentsMonthly,
  fetchAdminSignups,
  fetchMeDashboardSummary,
  fetchMeDashboardDailyDocs,
  fetchMeDashboardDocsMonthly,
  fetchMeDashboardTopTypes,
} from "../../helpers/backend-helper"

function* getUsers({ payload }) {
  try {
    const res = yield call(users, payload)
    yield put(apiSuccess(res?.data))
  } catch (error) {
    yield put(apiFail(
      error?.response ? error.response.data?.error || error.response.data?.message : "Something went wrong"
    ))
  }
}

function* createUser({ payload: { data, history, getUsersData } }) {
  try {
    const response = yield call(createUserData, data)
    yield put(createUserSuccess(response.message))
    yield put(getUsersData())
    history("/users")
  } catch (error) {
    yield put(
      createUserFail(
        error?.response ? error.response.data?.message || error.response.data?.message : "Something went wrong"
      )
    )
  }
}

function* getUser({ payload: { userId } }) {
  try {
    const res = yield call(getUserData, userId)
    const user = res?.data || res
    yield put(getUserSuccess(user))
  } catch (error) {
    yield put(
      getUserFail(
        error?.response
          ? error.response.data?.error || error.response.data?.message
          : "Something went wrong"
      )
    )
  }
}

function* updateUser({ payload: { data, history, getUsersData, getUser, userId } }) {
  try {
    const response = yield call(updateUserData, { data, userId })
    yield put(updateSuccess(response.message))
    if (getUsersData) yield put(getUsersData())
    if (getUser) yield put(getUser(userId))
    if (history) history("/users")
  } catch (error) {
    yield put(
      updateFail(
        error?.response ? error.response.data?.error || error.response.data?.message : "Something went wrong"
      )
    )
  }
}

function* deleteUser({ payload: { history, getUsersData, userId } }) {
  try {
    const response = yield call(deleteUserData, userId)
    yield put(deleteUserSuccess(response.message))
    yield put(getUsersData())
    history("/users")
  } catch (error) {
    yield put(
      deleteUserFail(
        error?.response ? error.response.data?.message || error.response.data?.message : "Something went wrong"
      )
    )
  }
}

function* fetchDomainsSaga() {
  try {
    const response = yield call(fetchDomainsApi)
    const domains = response?.data || []
    yield put(getDomainsSuccess(domains))
  } catch (err) {
    const msg =
      err?.response?.data?.message ||
      err?.message ||
      "Failed to fetch domains"
    yield put(getDomainsFailure(msg))
  }
}

function* fetchAdminSummary(action) {
  try {
    const response = yield call(fetchAdminData, action?.filters)
    const domains = response?.data || []
    yield put(getAdminDashboardSummarySuccess(domains))
  } catch (err) {
    const msg =
      err?.response?.data?.message ||
      err?.message ||
      "Failed to fetch domains"
    yield put(getAdminDashboardSummaryFailure(msg))
  }
}

function* wSignups(action) {
  try {
    const res = yield call(fetchAdminSignups, action.weeks, action?.filters);
    const payload = res?.data ?? res;
    yield put(getAdminDashboardSignupsSuccess(payload));
  } catch (err) {
    const msg = err?.response?.data?.message || err?.message || "Failed to fetch signups";
    yield put(getAdminDashboardSignupsFailure(msg));
  }
}

function* wDocsMonthly(action) {
  try {
    const res = yield call(fetchAdminDocumentsMonthly, action.year, action?.filters);
    const payload = res?.data ?? res;
    yield put(getAdminDashboardDocsMonthlySuccess(payload));
  } catch (err) {
    const msg = err?.response?.data?.message || err?.message || "Failed to fetch documents monthly";
    yield put(getAdminDashboardDocsMonthlyFailure(msg));
  }
}

function* wCompanyTypes(action) {
  try {
    const res = yield call(fetchAdminCompanyTypes, action?.filters);
    const payload = res?.data ?? res;
    yield put(getAdminDashboardCompanyTypesSuccess(payload));
  } catch (err) {
    const msg = err?.response?.data?.message || err?.message || "Failed to fetch company types";
    yield put(getAdminDashboardCompanyTypesFailure(msg));
  }
}

function* wActiveSessions(action) {
  try {
    const res = yield call(fetchAdminActiveSessions, action.interval, action?.filters);
    const payload = res?.data ?? res;
    yield put(getAdminDashboardActiveSessionsSuccess(payload));
  } catch (err) {
    const msg = err?.response?.data?.message || err?.message || "Failed to fetch active sessions";
    yield put(getAdminDashboardActiveSessionsFailure(msg));
  }
}

function* wMeSummary(action) {
  try {
    const res = yield call(fetchMeDashboardSummary, action?.filters);
    const payload = res?.data ?? res;
    yield put(getAdminDashboardSummarySuccess(payload));
  } catch (err) {
    const msg = err?.response?.data?.message || err?.message || "Failed to fetch my summary";
    yield put(getAdminDashboardSummaryFailure(msg));
  }
}

function* wMeDailyDocs(action) {
  try {
    const res = yield call(fetchMeDashboardDailyDocs, action?.filters);
    const payload = res?.data ?? res;
    yield put(getAdminDashboardActiveSessionsSuccess(payload));
  } catch (err) {
    const msg = err?.response?.data?.message || err?.message || "Failed to fetch my daily documents";
    yield put(getAdminDashboardActiveSessionsFailure(msg));
  }
}

function* wMeDocsMonthly(action) {
  try {
    const res = yield call(fetchMeDashboardDocsMonthly, action.year, action?.filters);
    const payload = res?.data ?? res;
    yield put(getAdminDashboardDocsMonthlySuccess(payload));
  } catch (err) {
    const msg = err?.response?.data?.message || err?.message || "Failed to fetch my monthly documents";
    yield put(getAdminDashboardDocsMonthlyFailure(msg));
  }
}

function* wMeTopTypes(action) {
  try {
    const res = yield call(fetchMeDashboardTopTypes, action?.filters);
    const payload = res?.data ?? res;
    yield put(getAdminDashboardCompanyTypesSuccess(payload));
  } catch (err) {
    const msg = err?.response?.data?.message || err?.message || "Failed to fetch my top types";
    yield put(getAdminDashboardCompanyTypesFailure(msg));
  }
}

function* getAssessments() {
  try {
    const response = yield call(assessments)
    yield put(assessmentapiSuccess(response?.assessments))
  } catch (error) {
    yield put(
      assessmentapiFail(
        error?.response ? error.response.data?.error : "Something went wrong"
      )
    )
  }
}

function* addAssessmentData({
  payload: { data, history, getAssessmentsData },
}) {
  try {
    const response = yield call(addAssessment, data)
    yield put(
      addAssessmentSuccess({
        message: response.message,
        assessmentId: response.assessment.id,
      })
    )
    getAssessmentsData()
    yield put({ type: GET_ASSESSMENTS_DATA })
  } catch (error) {
    yield put(
      addAssessmentFail(
        error?.response ? error.response.data?.message : "Something went wrong"
      )
    )
  }
}

function* updateAssessment({ payload: { data, history, getAssessmentsData } }) {
  try {
    const response = yield call(updateAssessmentData, data)
    yield put(
      updateAssessmentSuccess({
        message: response.message,
        assessmentId: data.id,
      })
    )
    getAssessmentsData()

    yield put({ type: GET_ASSESSMENTS_DATA })
    if (history) history("/dashboard")
  } catch (error) {
    yield put(
      updateAssessmentFail(
        error?.response ? error.response.data?.message : "Something went wrong"
      )
    )
  }
}

function* deleteAssessment({ payload: { id } }) {
  try {
    const response = yield call(deleteAssessments, id)
    yield put(deleteAssessmentSuccess({
      message: response.message,
      assessmentId: id,
    }))

    yield put({ type: GET_ASSESSMENTS_DATA });
  } catch (error) {
    yield put(
      deleteAssessmentFail(
        error?.response ? error.response.data?.message : "Something went wrong"
      )
    )
  }
}

function* stepBackForm({ payload }) {
  try {
    yield call({
      type: STEP_BACK,
      payload,
    })
  } catch (error) {
    console.log(error)
  }
}

function* stepNextForm({ payload }) {
  try {
    yield call({
      type: STEP_NEXT,
      payload,
    })
  } catch (error) {
    console.log(error)
  }
}

function* clearAssessmentDataId({ payload }) {
  // yield put(clearAssessmentId(payload))
}

function* goToDashboard({ payload }) {
  try {
    payload.history.push("/dashboard")
  } catch (error) {
    console.log(error)
  }
}

function* cloneAssessment({ payload: { assessmentId } }) {
  try {
    const response = yield call(clonePchAssessmentData, assessmentId)
    yield put(cloneAssessmentSuccess(response.assessment))
  } catch (error) {
    yield put(
      cloneAssessmentFail(
        error?.response ? error.response.data?.message : "Something went wrong"
      )
    )
  }
}

function* createPatient({ payload: { data, history } }) {
  try {
    const response = yield call(createNewPatient, data, history)
    yield put(createPatientSuccess(response.message))
    if (history) history("/patients")
  } catch (error) {
    yield put(
      createPatientFail(
        error?.response ? error.response.data?.message : "Something went wrong"
      )
    )
  }
}

function* getPatientData() {
  try {
    const response = yield call(getPatientsData)
    yield put(getPatientDataSuccess(response.patients))
  } catch (error) {
    yield put(
      getPatientDataFail(
        error?.response ? error.response.data?.error : "Something went wrong"
      )
    )
  }
}

function* updatePatient({
  payload: { data, history, getPatientData, patientId },
}) {
  try {
    const response = yield call(updatePatients, { ...data, id: patientId })
    yield put(
      updatePatientSuccess({
        message: response.message,
        id: patientId,
      })
    )
    if (getPatientData) getPatientData()
    if (history) history("/patients")
  } catch (error) {
    yield put(
      updatePatientFail(
        error?.response ? error.response.data?.message : "Something went wrong"
      )
    )
  }
}

function* deletePatient({ payload: { history, getPatientData, patientId } }) {
  try {
    const response = yield call(deletePatients, patientId)
    yield put(deletePatientSuccess(response.message))
    if (getPatientData) getPatientData()
    if (history) history("/patients")
  } catch (error) {
    yield put(
      deletePatientFail(
        error?.response ? error.response.data?.message : "Something went wrong"
      )
    )
  }
}

function* dashboardSaga() {
  yield takeEvery(GET_USERS_DATA, getUsers)
  yield takeEvery(CREATE_USER, createUser)
  yield takeEvery(GET_USER, getUser)
  yield takeEvery(UPDATE_USER, updateUser)
  yield takeEvery(DELETE_USER, deleteUser)
  yield takeEvery(GET_DOMAINS_REQUEST, fetchDomainsSaga)
  yield takeEvery(GET_ADMIN_DASHBOARD_SUMMARY_REQUEST, fetchAdminSummary)
  yield takeEvery(GET_ADMIN_DASHBOARD_SIGNUPS_REQUEST, wSignups),
    yield takeEvery(GET_ADMIN_DASHBOARD_DOCS_MONTHLY_REQUEST, wDocsMonthly),
    yield takeEvery(GET_ADMIN_DASHBOARD_COMPANY_TYPES_REQUEST, wCompanyTypes),
    yield takeEvery(GET_ADMIN_DASHBOARD_ACTIVE_SESSIONS_REQUEST, wActiveSessions),
    yield takeEvery(GET_ME_DASHBOARD_SUMMARY_REQUEST, wMeSummary);
  yield takeEvery(GET_ME_DASHBOARD_DAILY_DOCS_REQUEST, wMeDailyDocs);
  yield takeEvery(GET_ME_DASHBOARD_DOCS_MONTHLY_REQUEST, wMeDocsMonthly);
  yield takeEvery(GET_ME_DASHBOARD_TOP_TYPES_REQUEST, wMeTopTypes);
  yield takeEvery(GET_ASSESSMENTS_DATA, getAssessments)
  yield takeEvery(ADD_ASSESSMENT, addAssessmentData)
  yield takeEvery(UPDATE_ASSESSMENT_DATA, updateAssessment)
  yield takeEvery(DELETE_ASSESSMENT, deleteAssessment)
  yield takeEvery(STEP_BACK, stepBackForm)
  yield takeEvery(STEP_NEXT, stepNextForm)
  // yield takeEvery(CLEAR_ASSESSMENT_ID, clearAssessmentDataId)
  yield takeEvery(CLEAR_ASSESSMENT_ID, clearAssessmentId)
  yield takeEvery(CLONE_ASSESSMENT, cloneAssessment)
  yield takeEvery(CREATE_PATIENT, createPatient)
  yield takeEvery(GET_PATIENT_DATA, getPatientData)
  yield takeEvery(UPDATE_PATIENT, updatePatient)
  yield takeEvery(DELETE_PATIENT, deletePatient)
}
export default dashboardSaga
